export const LOCALSTORAGE_KEYS = {
  FILTERS: 'market_genie_filters',
  JWT_TOKEN: 'MG_JWT_TOKEN',
  DARK_MODE: 'DARK_MODE',
  COLOR_PALETTE: 'COLOR_PALETTE'
}
